export default function(userId) {
  if (window) window.analytics.identify(userId);
}
